import { Button, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";
import baseURL from "../../../configs/api";
import AddIdentification from "../../contacts/customers/AddIdentification";
import { format } from "date-fns";
import useAuth from "../../../components/hooks/useAuth";
import PhoneNumberInput from "../../../components/common/PhoneNumberInput";
import { getCustomersExtraInformationsByCustomerId } from "../../../services/customerExtraInformation";
import { getCustomer, post_Customer, put_Customer } from "../../../services/customer";
import useConfirm from "../../../components/hooks/useConfirm";
import { useTheme } from "../../../components/hooks/useTheme";
import { AddOutlined } from "@mui/icons-material";
import PleaseWaitPopup from "../../PleaseWaitPopup";
import colorConfigs from "../../../configs/colorConfigs";
import EmailValidatedComponent from "../../../components/EmailValidatedComponent";
import moment from "moment";
import useGeneral from "../../../components/hooks/useGeneral";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";

type ExtraInformation = {
  id: number;
  idNumber: string;
  issueDate: string;
  exprationDate: string;
  filePath: string;
  idTypeId: string;
  customerId: number;
  type: string;
  imageSize: number,
  uploadedAt: string,
  uploadedBy: string
};

type Props = {
  handleCustomer: (customerId: number, newCustomer?: any) => void;
  closeNewCustomer: () => void;
  customerId: number;
  isFromDriver: boolean;
  pickupDate: string;
  returnDate: string;
  returnTime: string;
};

const monthNameOptions = [
  { value: "1", label: "1. January" },
  { value: "2", label: "2. February" },
  { value: "3", label: "3. March" },
  { value: "4", label: "4. April" },
  { value: "5", label: "5. May" },
  { value: "6", label: "6. June" },
  { value: "7", label: "7. July" },
  { value: "8", label: "8. August" },
  { value: "9", label: "9. September" },
  { value: "10", label: "10. October" },
  { value: "11", label: "11. November" },
  { value: "12", label: "12. December" },
];

const daysOptions: any = [];
for (let i = 1; i <= 31; i++) {
  daysOptions.push({ value: i, label: i });
}

const yearOptions: any = [];
for (let i = 1940; i <= new Date().getFullYear(); i++) {
  yearOptions.push({ value: i, label: i });
}

yearOptions.reverse();

export const AddNewCustomer = ({
  handleCustomer,
  closeNewCustomer,
  customerId,
  isFromDriver,
  pickupDate,
  returnDate,
  returnTime
}: Props) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const { dateFormat }: any = useGeneral();
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [emailAddress, setEmailAddress] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [Street, setStreet] = useState<string>("");
  const [street2, setStreet2] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [isRedFlag, setIsRedFlag] = useState<boolean>(false);
  const [redFlagReason, setRedFlagReason] = useState<string>("");

  const [extraRow, setExtraRow] = useState<ExtraInformation[]>([]);
  const [allExtraValue, setAllExtraValue] = useState<boolean>(false);
  const [indexNumber, setIndexNumber] = useState<number>(1);

  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

  const handleAddExtraRow = () => {
    const data: ExtraInformation = {
      id: indexNumber,
      idNumber: "",
      issueDate: "",
      exprationDate: "",
      filePath: "",
      idTypeId: "",
      customerId: customerId,
      type: "POST",
      imageSize: 0,
      uploadedAt: moment(new Date()).format(dateFormat + " hh:mm:ss a"),
      uploadedBy: auth.givenname,
    };

    setExtraRow((extraRow: ExtraInformation[]) => [...extraRow, data]);

    setIndexNumber(() => indexNumber + 1);
  };

  const handleDeleteExtraRow = (index: number) => {
    if (extraRow.find((row: ExtraInformation) => row.id === index)?.type.split(" ")[0] === "PUT") {
      axios
        .delete(`${baseURL}customerExtraInformation?id=${extraRow.find((row: ExtraInformation) => row.id === index)?.type.split(" ")[1]}&userId=${auth?.id}`, {
          headers: {
            'X-Tenant-ID': tenantId
          }
        })
        .then(() => {
          const newRow: ExtraInformation[] = extraRow.filter(
            (row: ExtraInformation) => row.id !== index
          );
          setExtraRow(newRow);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      const newRow: ExtraInformation[] = extraRow.filter(
        (row: ExtraInformation) => row.id !== index
      );
      setExtraRow(newRow);
    }
  };

  const changeOnExtraValue = (row: ExtraInformation) => {
    setExtraRow((extraRow) =>
      extraRow.map((rowValue: ExtraInformation) => {
        return rowValue.id === row.id ? row : rowValue;
      })
    );
  };

  useEffect(() => {
    if (customerId) {
      getCustomer(customerId, tenantId)
        .then((data) => {
          setFirstName(data?.firstName);
          setLastName(data?.lastName);
          setEmailAddress(data?.emailAddress);
          setPhoneNumber(data?.phoneNumber);
          setStreet(data?.street);
          setStreet2(data?.street2);
          setCity(data?.city);
          setState(data?.state);
          setCountry(data?.country);
          setZip(data?.zip);
          setYear(new Date(data?.birthday).getFullYear().toString());
          setDay(new Date(data?.birthday).getDate().toString());
          setMonth((new Date(data?.birthday).getMonth() + 1).toString());
          setIsRedFlag(data?.isRedFlag);
          setRedFlagReason(data?.redFlagReason);
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      setFirstName("");
      setLastName("");
      setEmailAddress("");
      setPhoneNumber("");
      setStreet("");
      setStreet2("");
      setCity("");
      setState("");
      setCountry("");
      setZip("");

      setYear("");
      setDay("");
      setMonth("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId]);

  useEffect(() => {
    if (customerId > 0) {
      getCustomersExtraInformationsByCustomerId(customerId, tenantId)
        .then((data) => {
          setExtraRow(
            data?.filter((value: any) => value.idTypeId !== 0)
              ?.map((item: ExtraInformation, index: number) => {
                return {
                  id: index + 1,
                  idNumber: item.idNumber,
                  issueDate: format(new Date(item.issueDate), "yyyy-MM-dd"),
                  exprationDate: format(
                    new Date(item.exprationDate),
                    "yyyy-MM-dd"
                  ),
                  filePath: item.filePath,
                  idTypeId: item.idTypeId,
                  customerId: item.customerId,
                  type: `PUT ${item?.id}`,
                  imageSize: item.imageSize,
                  uploadedAt: item.uploadedAt,
                  uploadedBy: item.uploadedBy
                };
              })
          );

          if (data?.filter((item: ExtraInformation) => parseInt(item.idTypeId) !== 0)?.length > 0) {
            setAllExtraValue(true);
          }
          handleTenantError(null);
        })
        .catch((error) => {
          handleTenantError(error);
        });
    } else {
      setAllExtraValue(false);
      setIndexNumber(1);
      setExtraRow([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId]);

  useEffect(() => {
    if (allExtraValue) {
      const lastIndexValue: any = extraRow.find(
        (item: ExtraInformation) => extraRow[extraRow.length - 1] === item
      );

      if (lastIndexValue) {
        setIndexNumber(lastIndexValue?.id + 1);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allExtraValue]);

  const handleTheCustomerSubmit = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();

    if (isFromDriver) {
      if (extraRow?.length === 0) {
        setConfirmData({
          title: 'Warning',
          summary: "Please add customer extra info",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
        return;
      }

      let hasInvalidDate = false;

      if (extraRow?.length > 0) {
        extraRow?.forEach((item: any) => {
          if (item?.issueDate && moment(item?.issueDate, "YYYY-MM-DD", true)?.isValid() && item?.exprationDate && moment(item?.exprationDate, "YYYY-MM-DD", true)?.isValid()) {
            const returnDateTime = new Date(returnDate);
            const exprationDate = new Date(item?.exprationDate);

            const pickupDateTime = new Date(pickupDate);
            const issuedDate = new Date(item?.issueDate);

            if (exprationDate < issuedDate) {
              setConfirmData({
                title: 'Warning',
                summary: `The expiration date for ID (${item?.idNumber}) cannot be earlier than the issued date.`,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                },
              });

              setConfirmPopup(true);
              setPleaseWaitPopup(false);
              hasInvalidDate = true;
              return;
            }

            if (exprationDate < returnDateTime) {
              setConfirmData({
                title: 'Warning',
                summary: `The expiration date for ID (${item?.idNumber}) cannot be earlier than the return date and time.`,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                },
              });

              setConfirmPopup(true);
              setPleaseWaitPopup(false);
              hasInvalidDate = true;
              return;
            }

            if (issuedDate > pickupDateTime) {
              setConfirmData({
                title: 'Warning',
                summary: `The issued date for ID (${item?.idNumber}) cannot be later than the pickup date and time.`,
                confirmBtn: 'Ok',
                isConfirm: (callback: any) => {
                  callback();
                },
              });

              setConfirmPopup(true);
              setPleaseWaitPopup(false);
              hasInvalidDate = true;
              return;
            }
          } else {
            setConfirmData({
              title: 'Warning',
              summary: `Issued date and Expiration date format must be - ${dateFormat?.replace(/yyyy/g, 'YYYY')}`,
              confirmBtn: 'Ok',
              isConfirm: (callback: any) => {
                callback();
              },
            });

            setConfirmPopup(true);
            setPleaseWaitPopup(false);
            hasInvalidDate = true;
            return;
          }
        });
      }

      if (hasInvalidDate) return;

      if (customerId) {
        updateTheExtraCustomer(customerId);
      } else {
        saveNewCustomer();
      }
    } else {
      saveNewCustomer();
    }
  };

  // Update the extra of selected customer
  const updateTheExtraCustomer = async (id: number) => {
    setPleaseWaitPopup(true);
    if (extraRow?.length > 0) {
      extraRow.forEach(async (item: ExtraInformation, index: number) => {
        const returnDateTime = new Date(`${returnDate}T${returnTime}`);
        const exprationDate = new Date(item.exprationDate);

        if (exprationDate < returnDateTime) {
          setConfirmData({
            title: 'Warning',
            summary: `The expiration date for ID (${item.idNumber}) cannot be earlier than the return date and time.`,
            confirmBtn: 'Ok',
            isConfirm: (callback: any) => {
              callback();
            }
          });

          setConfirmPopup(true);
          setPleaseWaitPopup(false);
          return;
        }

        if (item.type.split(" ")[0] === "POST") {
          await axios
            .post(
              `${baseURL}customerExtraInformation?userId=${auth?.id}`,
              JSON.stringify({
                idNumber: item.idNumber,
                issueDate: new Date(item.issueDate),
                exprationDate: new Date(item.exprationDate),
                filePath: item.filePath,
                idTypeId: item.idTypeId,
                customerId: item.customerId,
                imageSize: item.imageSize,
                uploadedAt: new Date(item.uploadedAt),
                uploadedBy: item.uploadedBy
              }),
              {
                headers: {
                  'X-Tenant-ID': tenantId,
                  "Content-Type": "application/json"
                },
                withCredentials: true,
              }
            )
            .then(() => {
              if (extraRow?.length === (index + 1)) {
                updateTheCustomer(id);
              }
              handleTenantError(null);
            })
            .catch((error) => handleTenantError(error));
        } else if (item.type.split(" ")[0] === "PUT") {
          await axios
            .put(
              `${baseURL}customerExtraInformation?userId=${auth?.id}`,
              JSON.stringify({
                id: item.type.split(" ")[1],
                idNumber: item.idNumber,
                issueDate: new Date(item.issueDate),
                exprationDate: new Date(item.exprationDate),
                filePath: item.filePath,
                idTypeId: item.idTypeId,
                customerId: item.customerId,
                imageSize: item.imageSize,
                uploadedAt: new Date(item.uploadedAt),
                uploadedBy: item.uploadedBy
              }),
              {
                headers: {
                  'X-Tenant-ID': tenantId,
                  "Content-Type": "application/json"
                },
                withCredentials: true,
              }
            )
            .then(() => {
              if (extraRow?.length === (index + 1)) {
                updateTheCustomer(id);
              }
              handleTenantError(null);
            })
            .catch((error) => handleTenantError(error));
        } else {
          if (extraRow?.length === (index + 1)) {
            updateTheCustomer(id);
          }
        }
      });
    } else {
      updateTheCustomer(id);
    }
  };

  const updateTheCustomer = async (id: number) => {
    const paddedMonth = month.toString().padStart(2, "0");
    const paddedDay = day.toString().padStart(2, "0");
    const birthday = new Date(`${year}-${paddedMonth}-${paddedDay}`);

    put_Customer({
      id: id,
      firstName,
      lastName,
      emailAddress,
      phoneNumber,
      Street,
      street2,
      city,
      state,
      country,
      zip,
      birthday,
      isRedFlag,
      redFlagReason
    }, auth?.id, tenantId)
      .then(() => {
        handleCustomer(id,
          {
            value: id,
            label: firstName + " " + lastName,
            dob: new Date(`${year}-${month}-${day}`)?.toISOString()
          }
        );

        if (!isFromDriver) {
          closeNewCustomer();
        }
        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  }

  const saveNewCustomer = async () => {
    if (extraRow?.length === 0) {
      setConfirmData({
        title: 'Warning',
        summary: "Please add customer extra info",
        confirmBtn: 'Ok',
        isConfirm: (callback: any) => {
          callback();
        }
      });

      setConfirmPopup(true);
      return;
    }

    setPleaseWaitPopup(true);

    const customerExtraInformations = extraRow?.map((item: any) => {
      return {
        idNumber: item.idNumber,
        issueDate: new Date(item.issueDate),
        exprationDate: new Date(item.exprationDate),
        filePath: item.filePath,
        idTypeId: item.idTypeId,
        customerId: item.customerId,
        imageSize: item.imageSize,
        uploadedAt: new Date(item.uploadedAt),
        uploadedBy: item.uploadedBy
      };
    });

    await post_Customer({
      firstName,
      lastName,
      emailAddress,
      phoneNumber,
      Street,
      street2,
      city,
      state,
      country,
      zip,
      birthday: new Date(`${year}-${month}-${day}`),
      isRedFlag,
      redFlagReason,
      customerExtraInformations,
    }, auth?.id, tenantId)
      .then((response) => {
        const customerData = response;
        handleCustomer(customerData?.id,
          {
            value: customerData?.id,
            label: customerData?.firstName + " " + customerData?.lastName,
            dob: customerData?.birthday,
          }
        );

        if (!isFromDriver) {
          closeNewCustomer();
        }
        setPleaseWaitPopup(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setPleaseWaitPopup(false);
        handleTenantError(error);
      });
  };

  return (
    <>
      <div className="w-full mt-4">
        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Customer Information
        </span>

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <form onSubmit={(e) => handleTheCustomerSubmit(e)}>
          <div className="w-full px-2">
            <div className="grid grid-cols-2 gap-6">
              {/* Row 1 */}
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  First Name
                </label>
                <input
                  type="text"
                  tabIndex={1}
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  Last Name
                </label>
                <input
                  type="text"
                  tabIndex={2}
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </div>

              {/* Row 2 */}
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  Email Address
                </label>
                <EmailValidatedComponent
                  tabIndex={3}
                  text={emailAddress}
                  setText={setEmailAddress}
                  required={true}
                />
              </div>
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  Phone Number
                </label>
                <PhoneNumberInput
                  tabIndex={4}
                  name={"phoneNumber"}
                  value={phoneNumber}
                  setValue={setPhoneNumber}
                  fontSize={"14px"}
                  paddingBlock={"5px"}
                  required={true}
                />
              </div>

              {/* Row 3 */}
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  Street
                </label>
                <input
                  type="text"
                  tabIndex={5}
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={Street}
                  onChange={(e) => setStreet(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  Street 2
                </label>
                <input
                  type="text"
                  tabIndex={6}
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={street2}
                  onChange={(e) => setStreet2(e.target.value)}
                />
              </div>

              {/* Row 4 */}
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  City
                </label>
                <input
                  type="text"
                  tabIndex={7}
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  State
                </label>
                <input
                  type="text"
                  tabIndex={8}
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                  required
                />
              </div>

              {/* Row 5 */}
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  Zip
                </label>
                <input
                  type="text"
                  tabIndex={9}
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  Country
                </label>
                <input
                  type="text"
                  tabIndex={10}
                  className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  required
                />
              </div>
            </div>

            {/* Birthday Selects */}
            <div className="w-full mt-[16px] flex items-center gap-1.5">
              <div className="w-[30%]">
                <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>
                  Birthday
                </label>
                <Select
                  tabIndex={11}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      backgroundColor: "transparent",
                      color: themeStyles.form.inputTextColor,
                      borderRadius: '6px',
                      padding: '1px',
                      borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "14px",
                      backgroundColor: themeStyles.main.mainBg,
                      color: themeStyles.form.inputTextColor,
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? "#167AC3"
                        : state.isFocused
                          ? themeStyles.topBar.menuItemsHoverColor
                          : "transparent",
                      color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                      fontWeight: 600
                    }),
                    input: (base) => ({
                      ...base,
                      color: themeStyles.form.inputTextColor,

                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: themeStyles.form.inputTextColor,
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={false}
                  isLoading={false}
                  isClearable={false}
                  isRtl={false}
                  isSearchable={false}
                  name="birthday"
                  value={monthNameOptions.find(
                    (item) => item.value === month
                  )}
                  onChange={(month: any) =>
                    setMonth(month ? month.value : "")
                  }
                  options={monthNameOptions}
                  required
                />
              </div>
              <div className="mt-6">
                <Select
                  tabIndex={12}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      backgroundColor: "transparent",
                      color: themeStyles.form.inputTextColor,
                      borderRadius: '6px',
                      padding: '1px',
                      borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "14px",
                      backgroundColor: themeStyles.main.mainBg,
                      color: themeStyles.form.inputTextColor,
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? "#167AC3"
                        : state.isFocused
                          ? themeStyles.topBar.menuItemsHoverColor
                          : "transparent",
                      color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                      fontWeight: 600
                    }),
                    input: (base) => ({
                      ...base,
                      color: themeStyles.form.inputTextColor,

                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: themeStyles.form.inputTextColor,
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={false}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={true}
                  name="birthday"
                  value={daysOptions.find(
                    (item: any) => item.value === parseInt(day)
                  )}
                  onChange={(day: any) =>
                    setDay(day ? day.value : "")
                  }
                  options={daysOptions}
                  required
                />
              </div>
              <div className="mt-6">
                <Select
                  tabIndex={13}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      backgroundColor: "transparent",
                      color: themeStyles.form.inputTextColor,
                      borderRadius: '6px',
                      padding: '1px',
                      borderColor: state.isFocused ? "#167AC3" : themeStyles.form.borderColor,
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: "14px",
                      backgroundColor: themeStyles.main.mainBg,
                      color: themeStyles.form.inputTextColor,
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? "#167AC3"
                        : state.isFocused
                          ? themeStyles.topBar.menuItemsHoverColor
                          : "transparent",
                      color: state.isSelected ? "white" : themeStyles.topBar.textColor,
                      fontWeight: 600
                    }),
                    input: (base) => ({
                      ...base,
                      color: themeStyles.form.inputTextColor,

                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: themeStyles.form.inputTextColor,
                    }),
                  }}
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={false}
                  isLoading={false}
                  isClearable={true}
                  isRtl={false}
                  isSearchable={true}
                  name="birthday"
                  value={yearOptions.find(
                    (item: any) => item.value === parseInt(year)
                  )}
                  onChange={(year: any) =>
                    setYear(year ? year.value : "")
                  }
                  options={yearOptions}
                  required
                />
              </div>
            </div>
          </div>
          <div className="w-full mt-4">
            <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
              Extra Information
            </span>
            <Divider className={`w-full ${themeStyles.divider.bg}`} />

            <div className="w-full mt-2">

              <table className="min-w-full">
                <tbody className="text-left">
                  <tr className={`border-b ${themeStyles.main.borderColor}`}>
                    <th className={`w-[15%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Type</th>
                    <th className={`w-[25%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>ID Number</th>
                    <th className={`w-[20%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Issued On</th>
                    <th className={`w-[20%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>Exp. Date</th>
                    <th className={`w-[25%] text-[12px] font-semibold mb-2 py-2 ${themeStyles.table.tailwindHeaderColor} ${themeStyles.table.headerBg}`}>File</th>
                  </tr>

                  {extraRow?.map((row: ExtraInformation) => {
                    return (
                      <AddIdentification
                        key={row.id}
                        itemIndex={row.id}
                        birthDay={new Date(`${year}-${month}-${day}`).toDateString()}
                        handleDeleteExtraRow={(index) => handleDeleteExtraRow(index)}
                        row={row}
                        changeOnExtraValue={(row) => changeOnExtraValue(row)}
                      />
                    );
                  })}
                </tbody>
              </table>
              <div
                className="h-10 border-dashed border-t-0 border-l border-r border-b border-[#D5D4D8] mt-2 pt-1 flex justify-center items-center cursor-pointer"
                onClick={() => {
                  handleAddExtraRow();
                }}
              >
                <p className="text-xs text-center text-[#167AC3] cursor-pointer font-medium">
                  <AddOutlined
                    sx={{
                      fontSize: "16px",
                      textAlign: "center",
                    }}
                  />
                  Add another Identification
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-4 mt-6">
            <Button variant="contained"
              sx={{
                backgroundColor: colorConfigs.btn.main.bg
              }}
              type="submit">
              Save
            </Button>

            <Button variant="contained"
              sx={{
                backgroundColor: colorConfigs.btn.cancel.bg,
                border: colorConfigs.btn.cancel.border,
                color: colorConfigs.btn.cancel.color
              }}
              onClick={() => closeNewCustomer()}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  );
};
